import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ReportsPage } from '@features/admin/reports';
import { useAdminReportStore } from '@features/admin/reports/useAdminReportStore.ts';

const adminReportsSearchSchema = z.object({
  /** Část kódu nebo názvu reportu. */
  q: z.string().optional(),
});

export type AdminReportsSearch = z.infer<typeof adminReportsSearchSchema>;

export const Route = createFileRoute('/admin/reports/')({
  validateSearch: search => adminReportsSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    useAdminReportStore.getState().loadReports({ q: ctx.search.q });
  },
});

function RouteComponent() {
  return <ReportsPage />;
}
